import React from "react";

import { FormInstance } from "antd/es/form/hooks/useForm";
import { IntlShape } from "react-intl";

import { PopconfirmProps } from "@mapmycustomers/ui";

import MultilineText from "@app/component/typography/MultilineText";

const getConfirmationProps = (intl: IntlShape, form: FormInstance): PopconfirmProps => ({
  arrowPointAtCenter: true,
  cancelText: intl.formatMessage({
    id: "settings.profile.confirmLanguageChange.cancel",
    defaultMessage: "Wait",
    description: "Save profile settings confirmation's cancel button when language was changed",
  }),
  description: (
    <MultilineText>
      {intl.formatMessage({
        id: "settings.profile.confirmLanguageChange",
        defaultMessage:
          "In order to view the application in a new language, you\nmust refresh this page. Do you want to save your\nchanges and refresh the page?",
        description: "Save profile settings confirmation when language was changed",
      })}
    </MultilineText>
  ),
  okText: intl.formatMessage({
    id: "settings.profile.confirmLanguageChange.ok",
    defaultMessage: "Yes, Save and Refresh",
    description: "Save profile settings confirmation's ok button when language was changed",
  }),
  onConfirm: form.submit,
  placement: "bottomRight",
});

export default getConfirmationProps;
